import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AudioMessage_ClientPauseStatus } from "../../generated/audio_message";
import { updateClientInfoState } from "../../utils/protobuf_utils";
import "../../styles/components/sidepanel/SendFeedback.css";

interface Props {
  onSubmitFeedback: (message: string) => void;
  onCancelFeedback: () => void;
  botName?: string;
}

const SendFeedbackView: React.FC<Props> = ({ onSubmitFeedback, onCancelFeedback, botName }) => {
  const { t } = useTranslation();
  const [feedbackText, setFeedbackText] = useState("");

  useEffect(() => {
    updateClientInfoState({userPauseStatus: AudioMessage_ClientPauseStatus.PAUSE_SYLLABLE})
    return () => {
      updateClientInfoState({userPauseStatus: AudioMessage_ClientPauseStatus.PLAY})
    };
  }, []);

  const cancelFeedback = () => {
    setFeedbackText("");
    onCancelFeedback();
  };

  const submitFeedback = (message: string) => {
    if (message === "") {
      return;
    }
    onSubmitFeedback(message);
    setFeedbackText("");
  };

  return (
    <div className="sendfeedback-form">
      <p className="sendfeedback-description">
        {t("sendFeedback.description", { botName: botName || "Bella" })}
      </p>

      <textarea
        className="sendfeedback-textarea"
        placeholder={t("sendFeedback.placeholder")}
        value={feedbackText}
        onChange={(e) => setFeedbackText(e.target.value)}
      />

      <div className="sendfeedback-buttons">
        <button className="sendfeedback-cancel" onClick={cancelFeedback}>
          {t("sendFeedback.cancel")}
        </button>
        <button
          className="sendfeedback-send"
          disabled={feedbackText.trim() === ""}
          onClick={() => submitFeedback(feedbackText.trim())}
        >
          {t("sendFeedback.send")}
        </button>
      </div>
    </div>
  );
};

export default SendFeedbackView;
